// if ( typeof PickupAvailabilityCompact !== 'function' ) {

//   class PickupAvailabilityCompact extends HTMLElement {

//     constructor(){

//       super();
//       this.classList.add('active');

//       this.storeSelector = document.querySelector('store-selector[data-main-selector]');
//       if ( this.storeSelector ) {
//         const STORE_CHANGED_EVENT = () => {
//           this.fetchAvailability(this.dataset.variantId, true);
//         }
//         this.storeSelector.addEventListener('storechanged', STORE_CHANGED_EVENT);
// 				const observer = new MutationObserver(()=>{
//           this.storeSelector.removeEventListener('storechanged', STORE_CHANGED_EVENT);
// 					observer.disconnect();
// 				});
// 				observer.observe(this.parentElement, {
// 					attributes: false, childList: true, subtree: false
// 				});
//       }

//       if ( this.hasAttribute('data-static') ) {
//         this.fetchAvailability(this.dataset.variantId);
//       } else {
//         const widgetIntersection = (entries, observer) => {
//           if (!entries[0].isIntersecting) return;
//           observer.unobserve(this);
//           this.fetchAvailability(this.dataset.variantId);
//         }
//         new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 50px 0px'}).observe(this);
//       }
      
//     }

//     fetchAvailability(variantId, forceFetch = false) {

//       const pickupAvailabilityData = this.querySelector('[data-js-pickup-availability-data]');

//       if ( pickupAvailabilityData && ! forceFetch ) {
//         this.renderPreview(pickupAvailabilityData);
//       } else {

//         const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-compact`;

//         fetch(variantSectionUrl)
//           .then(response => response.text())
//           .then(text => {
//             const sectionInnerHTML = new DOMParser()
//               .parseFromString(text, 'text/html')
//               .querySelector('.shopify-section');
//             this.renderPreview(sectionInnerHTML);
//           })
//           .catch(e => {
//             console.log(e);
//           });

//       }

//     }
    
//     renderPreview(sectionInnerHTML) {
      
//       const selectedStore = localStorage.getItem('selected-store');

//       if ( this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore] ) {
//         // search based on selected store 
//         let storeFound = false;
//         if ( selectedStore ) {
//           sectionInnerHTML.querySelectorAll('.pickup-availability-alert').forEach(elm=>{
//             if ( selectedStore == elm.dataset.store ) {
//               this.innerHTML = elm.innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
//               storeFound = true;
//             }
//           })
//         }
//         if ( !storeFound ) {
//           this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]').innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
//           storeFound = true;
//         }
//         if ( !selectedStore || !storeFound ) {
//           this.innerHTML = '';
//         }
//       } else {
//         // search based on default store
//         this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-store]').innerHTML;
//       }

//     }
    
//   }

//   if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
//     customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
// 	}

// }












if ( typeof PickupAvailabilityCompact !== 'function' ) {

  class PickupAvailabilityCompact extends HTMLElement {
    
    constructor(){
      super();
      this.classList.add('active');
      this._storeListenerBound = false;
      this._intersectionObserver = null;
      this._handleStoreChanged = () => {
        this.fetchAvailability(this.dataset.variantId);
      };
    }

    connectedCallback() {
      const newStoreSelector = document.querySelector('store-selector[data-main-selector]') ||
        document.querySelector('store-selector');
      const shouldRebindStoreSelector =
        !this.storeSelector ||
        !this.storeSelector.isConnected ||
        this.storeSelector !== newStoreSelector;
      if (shouldRebindStoreSelector) {
        if (this.storeSelector && this._storeListenerBound) {
          this.storeSelector.removeEventListener('storechanged', this._handleStoreChanged);
          this._storeListenerBound = false;
        }
        this.storeSelector = newStoreSelector;
      }
      if ( this.storeSelector && !this._storeListenerBound ) {
        this.storeSelector.addEventListener('storechanged', this._handleStoreChanged);
        this._storeListenerBound = true;
      }

      const isDrawerOrCart = this.dataset.productDrawer === 'true' || this.dataset.cartPage === 'true';
      if (isDrawerOrCart) {
        this.fetchAvailability(this.dataset.variantId);
        return;
      }

      if (!this._intersectionObserver) {
        const IntersectionObserverCtor = window.IntersectionObserver;
        if (!IntersectionObserverCtor) {
          this.fetchAvailability(this.dataset.variantId);
          return;
        }
        const widgetIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.fetchAvailability(this.dataset.variantId);
        };
        this._intersectionObserver = new IntersectionObserverCtor(
          widgetIntersection.bind(this),
          {rootMargin: '0px 0px 50px 0px'}
        );
      }
      this._intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      if ( this.storeSelector && this._storeListenerBound ) {
        this.storeSelector.removeEventListener('storechanged', this._handleStoreChanged);
        this._storeListenerBound = false;
      }
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
        this._intersectionObserver = null;
      }
    }

    fetchAvailability(variantId) {
      const baseUrl = this.dataset.baseUrl || '';
      const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
      const variantSectionUrl = `${normalizedBaseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-compact`;
      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          console.log(e);
        });

    }
    
    renderPreview(sectionInnerHTML) {
      
      if($(document).find('#itg-product-variants').length){
        const selectedProductId = $(document).find('input[name="id"]').attr('value');
        $(document).find('[product-shipping-value]').attr('product-shipping-value',selectedProductId);
      }else if($(document).find('[data-quickview="true"]').length){
        const selectedQuickviewId = $(this).parents('[data-quickview="true"]').find('input[name="id"]').attr('value');
        $(document).find('[product-shipping-value]').attr('product-shipping-value',selectedQuickviewId);
      }
      
      const selectedStore = localStorage.getItem('selected-store');

     

      
      if ( this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore] ) {
        // search based on selected store 
        let storeFound = false;
        let productPageAvailiblity = this.getAttribute('data-product-page');
        let collectionPageAvailiblity = this.getAttribute('data-product-card');
        let checkDrawer = this.getAttribute('data-product-drawer');
        let drawerItemId = this.getAttribute('data-item-id');
        let checkCartPage = this.getAttribute('data-cart-page');
        let cartItemId = this.getAttribute('data-cart-item-id');
        let pickupAvailiblity = 'false';
        var pickupAvalable = $(document).find('#AjaxCartForm').data('pickup-available');
        var pickupUnAvalable = $(document).find('#AjaxCartForm').data('pickup-unavailable');
        let storeName = '';
        if (selectedStore) {
          sectionInnerHTML.querySelectorAll('.pickup-availability-alert').forEach(elm=>{
            if (selectedStore == elm.dataset.store) {
              this.innerHTML = elm.innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
              storeFound = true;
              if(checkDrawer == 'true' || checkCartPage == 'true' || collectionPageAvailiblity == 'true' || productPageAvailiblity == 'true'){
                var checkAvailiblity = $(elm).find('#change-store').attr('data-available');
                storeName = $(elm).find('#change-store').attr('data-store-name');
                pickupAvailiblity = checkAvailiblity;
              }
            }
          })
        }
        var storeText = "Store";
        if(storeName == "Toronto"){
          if(window.location.href.indexOf("/fr") > -1) {
            storeText = "Entrepôt";
          }else{
            storeText = "Warehouse";
          }
        }else{
          if(window.location.href.indexOf("/fr") > -1) {
            storeText = "Magasin";
          }
        }
        /*==============  Update cart drawer ===============*/
        if(checkDrawer == 'true'){
          if(pickupAvailiblity == 'false'){
            $(document).find('div[data-availability-id="'+drawerItemId+'"]').find('span[data-pickup]').removeClass('alert--success alert--note alert--circle-loading').addClass('alert--error pickup-not-available');
          }else if(pickupAvailiblity == 'true'){
            $(document).find('div[data-availability-id="'+drawerItemId+'"]').find('span[data-pickup]').addClass('alert--success').removeClass('alert--note alert--circle-loading alert--error pickup-not-available');
          }
        }else if(checkCartPage == 'true'){
        /*==============  Update cart page ===============*/
          if(pickupAvailiblity == 'false'){
            $(document).find('div[data-availability-id="'+cartItemId+'"]').find('span[data-pickup-availability]').removeClass('alert--success alert--note alert--circle-loading').addClass('alert--error pickup-not-available').text(pickupUnAvalable+' '+storeName+' '+storeText);
            $(document).find('.cart-store-change').show();
          }else if(pickupAvailiblity == 'true'){
            $(document).find('div[data-availability-id="'+cartItemId+'"]').find('span[data-pickup-availability]').addClass('alert--success').removeClass('alert--note alert--circle-loading alert--error pickup-not-available').text(pickupAvalable+' '+storeName+' '+storeText);
            $(document).find('.cart-store-change').show();
          }
        }
        itgDeliveryConflict();
        if ( !storeFound ) {
          this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]').innerHTML.replace('{{ store }}', this.storeSelector.storesList[selectedStore]);
          storeFound = true;
        }
        if ( !selectedStore || !storeFound ) {
          this.innerHTML = '';
        }
      } else {
        // search based on default store
        this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-store]').innerHTML;
      }
      if($(document).find('script#itg-shipping-availability').length){
        var deliverySuccess = $(document).find('body').data('delivery-success');
        var deliveryError = $(document).find('body').data('delivery-error');
        let shippingAvailabilityArray = $(document).find('script#itg-shipping-availability').html();
        shippingAvailabilityArray = JSON.parse(shippingAvailabilityArray);
        $(document).find('[data-shipping-id]').each(function(){
          var thisVariantId = $(this).data('shipping-id');
          if($(this).attr('product-shipping-value')){
            thisVariantId = parseInt($(this).attr('product-shipping-value'));
          }
          var thisElement = $(this);
          var thisDrawer = $(this).data('drawer');
          shippingAvailabilityArray.forEach(function(variantData) {
            if(thisVariantId == variantData['variant-id']){
              if(variantData['available'] == 'true'){
                if(thisDrawer === true){
                  thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success');
                }else{
                  thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success').text(deliverySuccess);
                }
              }else{
               if(thisDrawer === true){
                  thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery');
               }else{
                  thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery').text(deliveryError);
               }
              }
            }
          });
        });
      }
      if($(document).find('script#itg-item-shipping-availability').length){
        let itemShippingAvailabilityArray = $(document).find('script#itg-item-shipping-availability').html();
        itemShippingAvailabilityArray = JSON.parse(itemShippingAvailabilityArray);
        $(document).find('.itg-drawer-availability [data-shipping-id]').each(function(){
          var thisVariantId = $(this).data('shipping-id');
          var thisElement = $(this);
          itemShippingAvailabilityArray.forEach(function(variantData) {
            if(thisVariantId == variantData['variant-id']){
              if(variantData['available'] == 'true'){
                thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success');
              }else{
                thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery');
              }
            }
          });
        });
      }
      if($(document).find('[data-quickview="true"]').length){
        let quickviewItemShippingAvailabilityArray = $(document).find('script#itg-item-shipping-availability').html();
        quickviewItemShippingAvailabilityArray = JSON.parse(quickviewItemShippingAvailabilityArray);
        var thisVariantId = $(document).find('[data-quickview="true"]').find('[product-shipping-value]').attr('product-shipping-value');
        var thisElement = $(document).find('[data-quickview="true"]').find('[product-shipping-value]');
        quickviewItemShippingAvailabilityArray.forEach(function(variantData) {
          if(thisVariantId == variantData['variant-id']){
            if(variantData['available'] == 'true'){
              thisElement.removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success').text(deliverySuccess);
            }else{
              thisElement.removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery').text(deliveryError);
            }
          }
        });
      }
      var pickText = 'Pickup';
      var selectStore = 'Select store';
      if (window.location.href.indexOf("/fr") > -1) {
         pickText = 'Ramasser';
         selectStore = 'Sélectionnez le magasin';
      }
      if(selectedStore == null || selectedStore == 'null'){
        var thisText = $(document).find('[data-cart-first]').find('span').text();
        $(document).find('[data-pickup-availability]').text(thisText).attr('id','change-store');
        $(document)
          .find('.itg-drawer-availability')
          .find('[data-pickup]')
          .removeClass('alert--circle-loading alert--success alert--error pickup-not-available')
          .addClass('alert--note')
          .text(selectStore);
      }else{
        $(document).find('.itg-drawer-availability').find('[data-pickup]').text(pickText);
      }

      // if (selectedStore) {
      //   Rebuy.Sessions.update({
      //     pickup_location: selectedStore
      //   });
      // }
      
    }
  }

  if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
    customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
	}

}

if ( typeof PickupAvailabilityExtended !== 'function' ) {

  class PickupAvailabilityExtended extends HTMLElement {

    constructor() {
      super();
      this.classList.add('active');
      this.fetchAvailability(this.dataset.variantId);
    }


    fetchAvailability(variantId , forceFetch = false) {

      const pickupAvailabilityData = this.querySelector('[data-js-pickup-availability-data]');

      if ( pickupAvailabilityData && ! forceFetch ) {
        this.renderPreview(pickupAvailabilityData);
      } else {

        // const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-compact`;
       
        const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-extended`;

        // const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-pickup-availability-extended`;

        fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            console.log(e);
          });

      }
    } 

    renderPreview(sectionInnerHTML) {
      const availabilityWidget = sectionInnerHTML.querySelector('#PickupAvailabilityWidget');
      if ( availabilityWidget ) {
        this.innerHTML = availabilityWidget.innerHTML;
        this.querySelectorAll('.pickup-availability-widget__location-view').forEach(elm=>{
          elm.addEventListener('click', ()=>{
            document.getElementById(`${elm.getAttribute('aria-controls')}`).classList.toggle('opened');
            elm.setAttribute('aria-selected', elm.getAttribute('aria-selected') == "true" ? "false" : "true");
          })
        })
      } else {
        console.log('error in availablity fetch');
      }

      const availabilitySidebar = sectionInnerHTML.querySelector('#PickupAvailabilitySidebar');
      if ( availabilitySidebar ) {
        if ( document.querySelector('sidebar-drawer#site-availability-sidebar') ) {
          document.querySelector('sidebar-drawer#site-availability-sidebar').remove();
        } 
        document.body.appendChild(availabilitySidebar.querySelector('#site-availability-sidebar'));
        document.querySelector('.pickup-availability-widget__more').addEventListener('click', e=>{
          e.preventDefault();
          document.getElementById('site-availability-sidebar').show();
        })
      }

    }

  }

  if ( typeof customElements.get('pickup-availability-extended') == 'undefined' ) {
    customElements.define('pickup-availability-extended', PickupAvailabilityExtended);
	}

}

function itgResolveTermsCheckboxForCheckoutButton(btn) {
  let current = btn.parentElement;
  while (current && current !== document.body) {
    const scopedCheckbox = current.querySelector(ITG_TERMS_SELECTOR);
    if (scopedCheckbox) {
      return scopedCheckbox;
    }
    current = current.parentElement;
  }

  const allCheckoutButtons = Array.from(document.querySelectorAll(ITG_CHECKOUT_SELECTOR));
  const allTermsCheckboxes = Array.from(document.querySelectorAll(ITG_TERMS_SELECTOR));
  const buttonIndex = allCheckoutButtons.indexOf(btn);
  if (buttonIndex > -1 && allTermsCheckboxes[buttonIndex]) {
    return allTermsCheckboxes[buttonIndex];
  }

  return document.querySelector(ITG_TERMS_SELECTOR);
}

function itgSetCheckoutButtonDisabledState(btn, shouldDisable) {
  btn.disabled = shouldDisable;
  btn.style.opacity = shouldDisable ? 0.5 : 1;
  btn.style.pointerEvents = shouldDisable ? 'none' : 'auto';
}

const ITG_CHECKOUT_SELECTOR = 'button#CheckOut';
const ITG_TERMS_SELECTOR = '#AgreeToTos';
const ITG_PENDING_LOCK_ATTR = 'data-availability-pending-disabled';
const ITG_DELIVERY_CONFLICT_LOCK_ATTR = 'data-delivery-conflict-disabled';
const ITG_DELIVERY_CONFLICT_ALERT_SELECTOR = '.alert-delivery-conflict';
const ITG_DELIVERY_CONFLICT_ALERT_HTML = '<div class="alert-delivery-conflict"><strong><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="alert-triangle"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> Delivery conflict detected in your cart:</strong> Your items can be picked up in store or delivered, but not both in one order. You must place two orders.</div>';

window.itgResolveTermsCheckboxForCheckoutButton = itgResolveTermsCheckboxForCheckoutButton;
window.itgSetCheckoutButtonDisabledState = itgSetCheckoutButtonDisabledState;

function itgSetCheckoutAvailabilityPending(isPending) {
  const checkoutBtns = document.querySelectorAll(ITG_CHECKOUT_SELECTOR);

  checkoutBtns.forEach(btn => {
    const termsCheckbox = itgResolveTermsCheckboxForCheckoutButton(btn);

    if (isPending) {
      btn.setAttribute(ITG_PENDING_LOCK_ATTR, 'true');
    } else if (btn.getAttribute(ITG_PENDING_LOCK_ATTR) === 'true') {
      btn.removeAttribute(ITG_PENDING_LOCK_ATTR);
    }

    const hasDeliveryConflict = btn.getAttribute(ITG_DELIVERY_CONFLICT_LOCK_ATTR) === 'true';
    if (hasDeliveryConflict) {
      itgSetCheckoutButtonDisabledState(btn, true);
      return;
    }

    if (termsCheckbox && !termsCheckbox.checked) {
      itgSetCheckoutButtonDisabledState(btn, true);
      return;
    }

    itgSetCheckoutButtonDisabledState(btn, false);
  });
}

window.itgSetCheckoutAvailabilityPending = itgSetCheckoutAvailabilityPending;

function itgDeliveryConflict(){
  var deliveryConflictIntervalRef = window.itgDeliveryConflictInterval || null;
  var selectedStore = localStorage.getItem('selected-store');
  var hasSelectedStore = !!selectedStore && selectedStore !== 'null' && selectedStore !== 'undefined';

  function toggleCheckoutForDeliveryConflict(hasConflict) {
    const checkoutBtns = document.querySelectorAll(ITG_CHECKOUT_SELECTOR);

    checkoutBtns.forEach(btn => {
      const termsCheckbox = itgResolveTermsCheckboxForCheckoutButton(btn);

      if (hasConflict) {
        btn.setAttribute(ITG_DELIVERY_CONFLICT_LOCK_ATTR, 'true');
        itgSetCheckoutButtonDisabledState(btn, true);
        return;
      }

      if (btn.getAttribute(ITG_DELIVERY_CONFLICT_LOCK_ATTR) !== 'true') {
        return;
      }

      btn.removeAttribute(ITG_DELIVERY_CONFLICT_LOCK_ATTR);

      if (termsCheckbox && !termsCheckbox.checked) {
        itgSetCheckoutButtonDisabledState(btn, true);
        return;
      }

      itgSetCheckoutButtonDisabledState(btn, false);
    });
  }

  if (deliveryConflictIntervalRef) {
    clearInterval(deliveryConflictIntervalRef);
  }

  if (!hasSelectedStore) {
    $(document).find('body').removeClass('delivery-conflict');
    $(document).find(ITG_DELIVERY_CONFLICT_ALERT_SELECTOR).remove();
    toggleCheckoutForDeliveryConflict(false);
    itgSetCheckoutAvailabilityPending(false);
    window.itgDeliveryConflictInterval = null;
    return;
  }

  itgSetCheckoutAvailabilityPending(true);
  $(document).find('body').removeClass('delivery-conflict');
  $(document).find(ITG_DELIVERY_CONFLICT_ALERT_SELECTOR).remove();

  window.itgDeliveryConflictInterval = setInterval(function(){
    const cartForm = $(document).find('#AjaxCartForm');
    if (!cartForm.length) {
      clearInterval(window.itgDeliveryConflictInterval);
      window.itgDeliveryConflictInterval = null;
      itgSetCheckoutAvailabilityPending(false);
      return;
    }

    const hasLoadingStates = cartForm.find('.alert--circle-loading').length > 0;
    if (hasLoadingStates) {
      itgSetCheckoutAvailabilityPending(true);
      return;
    }

    itgSetCheckoutAvailabilityPending(false);

    const hasPickupUnavailable = cartForm.find('.pickup-not-available').length > 0;
    const hasDeliveryUnavailable = cartForm.find('.unavailable-delivery').length > 0;
    const hasConflict = hasPickupUnavailable && hasDeliveryUnavailable;

    if (hasConflict) {
      if (!$(document).find(ITG_DELIVERY_CONFLICT_ALERT_SELECTOR).length) {
        cartForm.prepend(ITG_DELIVERY_CONFLICT_ALERT_HTML);
      }
      $(document).find('body').addClass('delivery-conflict');
      toggleCheckoutForDeliveryConflict(true);
    } else {
      $(document).find('body').removeClass('delivery-conflict');
      $(document).find(ITG_DELIVERY_CONFLICT_ALERT_SELECTOR).remove();
      toggleCheckoutForDeliveryConflict(false);
    }

    clearInterval(window.itgDeliveryConflictInterval);
    window.itgDeliveryConflictInterval = null;
  },100);
}
itgDeliveryConflict();